import moment from "moment";
import ReactDatePicker from "react-datepicker"

interface IMonthCalendarProps {
  date: string | null | undefined;
  onChange: (date: string) => void;
}

const MonthContent = (month: number, shortMonth: string, longMonth: string) => {
  return <div className="px-2 py-2">{shortMonth}</div>;
};

export const MonthCalendar = ({ date, onChange}: IMonthCalendarProps) => {
  return (
    <ReactDatePicker
      selected={date ? moment(date, 'MM-YYYY').toDate() : null}
      onChange={(date) => {
        onChange(moment(date).format("MM-YYYY"));
      }}
      calendarStartDay={1}
      calendarClassName="!border-0"
      inline
      disabledKeyboardNavigation
      showMonthYearPicker={true}
      renderMonthContent={MonthContent}
    />
  )
}